import React from "react"
import LexicalErrorBoundary from "@lexical/react/LexicalErrorBoundary"
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin"
import { ContentEditable } from "@lexical/react/LexicalContentEditable"
import { EditorComposer } from "./context/LexicalComposer"
import { Box, Text } from "@mos-cat/ds"

import styles from "./editor.module.css"
import TableOfContentPlugin from "@editor/plugins/TableOfContentPlugin"
import CodeHighlightPlugin from "../form/Editor/plugins/CodeHighlightPlugin"

const PlaceholderComp = ({ children }) => {
  return (
    <Text as={Box} marginTop="-20px" color="gray-40">
      {children}
    </Text>
  )
}

export const CommentEditorPreview = ({ content, onClick, placeholder = "" }) => {
  return (
    <div
      className={styles.editorPreview__container}
      style={{ cursor: onClick ? "pointer" : "default" }}
      onClick={onClick}
    >
      <EditorComposer key={JSON.stringify(content)} readonly={true} jsonState={content}>
        <div className={styles.editorPreview__inner}>
          <RichTextPlugin
            ErrorBoundary={LexicalErrorBoundary}
            contentEditable={<ContentEditable className={styles.editorPreview__input} />}
            placeholder={<PlaceholderComp>{placeholder}</PlaceholderComp>}
          />
        </div>
        <TableOfContentPlugin />
        <CodeHighlightPlugin />
      </EditorComposer>
    </div>
  )
}
